import { createGlobalStyle } from 'styled-components';
import europa from "./fonts/Europa.ttf";
import europaBold from "./fonts/Europa-Bold.ttf";

export const GlobalStyle = createGlobalStyle`
    // @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Poppins:wght@400;500;600;700&family=Source+Serif+4:opsz,wght@8..60,400;8..60,600;8..60,700&display=swap");
    // @font-face {
    //   font-family: 'Source Serif', serif;
    //   src: url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Poppins:wght@400;500;600;700&family=Source+Serif+4:opsz,wght@8..60,400;8..60,600;8..60,700&display=swap");
    // }
    //     @font-face {
    //         font-family: "Europa";
    //         src: url(${europa}) format('woff');
    //     }
    //     @font-face {
    //         font-family: "Europa-Regular";
    //         src: url(${europa}) format('woff');
    //         font-weight: normal;
    //     }
    //     @font-face {
    //         font-family: "Europa-Bold";
    //         src: url(${europaBold}) format('woff');
    //     }
    * {
        box-sizing:border-box;
    }
    :root {
        --vh: 100%;
    }
    html, body, div, span, applet, object, iframe,
    h1, h2, h3, h4, h5, h6, p, blockquote, pre,
    a, abbr, acronym, address, big, cite, code,
    del, dfn, em, img, ins, kbd, q, s, samp,
    small, strike, strong, sub, sup, tt, var,
    b, u, i, center,
    dl, dt, dd, ol, ul, li,
    fieldset, form, label, legend,
    table, caption, tbody, tfoot, thead, tr, th, td,
    article, aside, canvas, details, embed,
    figure, figcaption, footer, header, hgroup,
    menu, nav, output, ruby, section, summary,
    time, mark, audio, video {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        vertical-align: baseline;

    }
    article, aside, details, figcaption, figure,
        footer, header, hgroup, menu, nav, section {
        display: block;
    }
    body {
        line-height: 1;
        background: #eee;
        //font-family: "Europa Regular"!important;
        //font-family: AppleGothic;
    }   
    ol, ul {
        list-style: none;
    }
    blockquote, q {
        quotes: none;
    }
    blockquote:before, blockquote:after,
        q:before, q:after {
        content: '';
        content: none;
    }
    table {
        border-collapse: collapse;
        border-spacing: 0;
    }
    textarea{
        resize: none!important;
        &:focus{
            border: solid 2px #333!important;
            box-sizing: border-box!important;
        }
    }
    a {
        color:#2f2a30;
    }
    img {
        vertical-align:top;
        max-width: 100%;
    }
    input{
        transition: all 0.2s!important;
        box-sizing: border-box!important;
        &:focus{
            border: solid 2px #333!important;
            //outline: solid 2px #333!important;
          
        }
    }
    button{
        &.continue{
            font-family: Europa-Regular;
            font-size: 18px;
            font-weight: 400;
            line-height: 18px;
            text-align: left;
        }
    }
`;


